import radish from "../assets/colors/radish.webp";
import jimmaron from "../assets/colors/jimmaron.webp";
import cranberry from "../assets/colors/cranberry.webp";
import deepWine from "../assets/colors/deepWine.webp";
import freshFuschia from "../assets/colors/freshFuschia.webp";
import orange from "../assets/colors/orange.webp";
import internationalOrange from "../assets/colors/internationalOrange.webp";
import peach from "../assets/colors/peach.webp";
import fabGold from "../assets/colors/fabGold.webp";
import deepGold from "../assets/colors/deepGold.webp";
import neonYellow from "../assets/colors/neonYellow.webp";
import hunter from "../assets/colors/hunter.webp";
import emerald from "../assets/colors/emerald.webp";
import lightGreen from "../assets/colors/lightGreen.webp";
import springGreen from "../assets/colors/springGreen.webp";
import neonGreen from "../assets/colors/neonGreen.webp";
import teal from "../assets/colors/teal.webp";
import iceMint from "../assets/colors/iceMint.webp";
import ocean from "../assets/colors/ocean.webp";
import peacock from "../assets/colors/peacock.webp";
import babyBlue from "../assets/colors/babyBlue.webp";
import celeste from "../assets/colors/celeste.webp";
import turquoise from "../assets/colors/turquoise.webp";
import topaz from "../assets/colors/topaz.webp";
import amythst from "../assets/colors/amythst.webp";
import eggplant from "../assets/colors/eggplant.webp";
import helio from "../assets/colors/helio.webp";
import concord from "../assets/colors/concord.webp";
import lavender from "../assets/colors/lavender.webp";
import lilac from "../assets/colors/lilac.webp";
import neonCerise from "../assets/colors/neonCerise.webp";
import rosePink from "../assets/colors/rosePink.webp";
import fragrantRose from "../assets/colors/fragrantRose.webp";
import black from "../assets/colors/black.webp";
import storm from "../assets/colors/storm.webp";
import eggshell from "../assets/colors/eggshell.webp";
import brown from "../assets/colors/brown.webp";
import caramel from "../assets/colors/caramel.webp";
import irishGold from "../assets/colors/irishGold.webp";

export const randomColors = [
  { name: "Radish", value: "#DB134B", icon: radish },
  { name: "Jimmaron", value: "#B33E6E", icon: jimmaron },
  { name: "Cranberry", value: "#C23A66", icon: cranberry },
  { name: "Deep Wine", value: "#B93C74", icon: deepWine },
  { name: "Fresh Fuschia", value: "#C01D6A", icon: freshFuschia },
  { name: "Orange", value: "#F3785B", icon: orange },
  { name: "International Orange", value: "#FB5E3F", icon: internationalOrange },
  { name: "Peach", value: "#E2C4BA", icon: peach },
  { name: "Fab Gold", value: "#E6D130", icon: fabGold },
  { name: "Deep Gold", value: "#E3B45B", icon: deepGold },
  { name: "Neon Yellow", value: "#87C823", icon: neonYellow },
  { name: "Hunter", value: "#7DA489", icon: hunter },
  { name: "Emerald", value: "#63C176", icon: emerald },
  { name: "Light Green", value: "#A1C776", icon: lightGreen },
  { name: "Spring Green", value: "#BED0B1", icon: springGreen },
  { name: "Neon Green", value: "#6DE570", icon: neonGreen },
  { name: "Teal", value: "#238787", icon: teal },
  { name: "Ice Mint", value: "#7DC0F3", icon: iceMint },
  { name: "Ocean", value: "#2768E2", icon: ocean },
  { name: "Peacock", value: "#05A0F6", icon: peacock },
  { name: "Baby Blue", value: "#91BCF6", icon: babyBlue },
  { name: "Celeste", value: "#5BBDF7", icon: celeste },
  { name: "Turquoise", value: "#34C4FC", icon: turquoise },
  { name: "Topaz", value: "#4390E7", icon: topaz },
  { name: "Amythst", value: "#A25CE1", icon: amythst },
  { name: "Eggplant", value: "#5E4191", icon: eggplant },
  { name: "Helio", value: "#866AB3", icon: helio },
  { name: "Concord", value: "#715BC2", icon: concord },
  { name: "Lavender", value: "#BE9FC1", icon: lavender },
  { name: "Lilac", value: "#A4A1DF", icon: lilac },
  { name: "Neon Cerise", value: "#F040C2", icon: neonCerise },
  { name: "Rose Pink", value: "#F09FCD", icon: rosePink },
  { name: "Fragrant Rose", value: "#E474A3", icon: fragrantRose },
  { name: "Black", value: "#2E3034", icon: black },
  { name: "Storm", value: "#9FA09E", icon: storm },
  { name: "Eggshell", value: "#FFFFFF", icon: eggshell },
  { name: "Brown", value: "#9E5E5C", icon: brown },
  { name: "Caramel", value: "#D27855", icon: caramel },
  { name: "Irish Gold", value: "#BBAC9D", icon: irishGold },
];
